var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 29v21h79V29",
    stroke: "var(--a, #000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.185 29.832l25.321 20 25.32-20M40.53 49.58V0",
    stroke: "var(--a, #000)"
  })));
}

export default SvgUpload;